import { default as ShiftListPage } from './shifts-list/shifts-list'
import { QrAttendance as QrAttendancePage } from './qr-attendance/qr-attendance'

export const ShiftsAttendanceStack = {
  ShiftListPage,
  QrAttendancePage,
}
